// extracted by mini-css-extract-plugin
export default {"tooltip":"qP-z","arrow":"rP-z"};